import React from 'react';
import PropTypes from 'prop-types';

import I18n from "redux-i18n";
import { translations } from '../translations/tr';
import { useSelector } from 'react-redux';

import * as settings from '../constants/SettingsKeys';
import G5DevicesModal from '../components/G5DevicesManagement/G5DevicesModal';
import CDashboardModal from '../containers/CDashboardModal/CDashboardModal';
import CMaintenanceDashboardModal from '../containers/CMaintenanceDashboardModal/CMaintenanceDashboardModal';
import CAutoRecommendedAlertsModal from '../containers/CAutoRecommendedAlerts/CAutoRecommendedAlertsModal';
import CustomerDashboardModal from '../components/CustomerDashboardModal/CustomerDashboardModal';

export default function App(props) {

  const initialLanguage = localStorage.getItem(settings.LANGUAGE) || 'en';
  const [language, setLanguageState] = React.useState(initialLanguage);

  const currentLang = useSelector((state) => state.i18nState.lang);

  // React.useEffect(() => {
  //   if (currentLang && currentLang !== language) {
  //     setLanguageState(currentLang);
  //     localStorage.setItem(settings.LANGUAGE, currentLang);
  //   }
  // }, [currentLang, language]);

  React.useEffect(() => {
    setLanguageState(initialLanguage);
  }, []);

  return (
    <I18n translations={translations} initialLang={language} key={language}>
      <div className="page-container">
        {props.children}
        {/* G5 Devices modal overlay */}
        <G5DevicesModal />
        {/* Dashboard modal overlay */}
        <CDashboardModal />
        {/* Maintenance dashboard modal overlay */}
        <CMaintenanceDashboardModal />
        {/* Auto Recommended Alerts panel overlay */}
        <CAutoRecommendedAlertsModal />
        {/* Customer Dashboard modal overlay */}
        <CustomerDashboardModal />
      </div>
    </I18n>
  );
}

App.propTypes = {
  children: PropTypes.element.isRequired
};
